import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import dayjs from 'dayjs';

export const useUserDateFormatter = () => {
  const { dateFormat } = useSelector((state: RootState) => state.userConfig);

  const formatDate = useCallback(
    (
      date: string | Date | dayjs.Dayjs | null | undefined,
      fallbackFormat?: string
    ) => {
      if (!date) return '';
      const formatString = dateFormat || fallbackFormat || 'DD-MM-YYYY';
      return dayjs(date).format(formatString);
    },
    [dateFormat]
  );

  return { dateFormat, formatDate };
};
